module.exports = __webpack_public_path__ + "media/images/common/frame-a7439f1766e262b97f1ecb5e010aab0e.svg";